const generateColors = (seed) => {
  const randomSeed = seed !== undefined ? seed : Math.random();
  const random = (min, max) => Math.floor(randomSeed * (max - min + 1)) + min;

  const lightness = random(85, 95);
  const saturation = random(40, 60);
  const hue = random(0, 360);

  const background = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

  return {
    backgroundColor: background,
    color: "#333"
  };
};

export { generateColors };
